import styled from 'styled-components';

export const AccessGateWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const AccessGateInternal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

export const AccessGateTitle = styled.h1`
  font-size: 2.5rem;
  color: ${props => props.theme.evTeal};
  margin: 0;
`;

export const AccessGateParagraph = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.voltBlue};
  line-height: 1.7;
  margin: 0;
`;

export const AccessGateErrorText = styled.p`
  font-size: 0.9rem;
  color: red;
  margin: 0;
`;

export const AccessGateInput = styled.input`
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: 2px solid ${props => props.theme.evTeal};
  border-radius: 4px;
  width: 300px;
  text-align: center;
  outline: none;

  &:focus {
    border-color: ${props => props.theme.voltBlue};
  }
`;

export const AccessGateButton = styled.button`
  background-color: ${props => props.theme.evTeal};
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.5rem;

  &:hover {
    background-color: ${props => props.theme.eLime};
  }

  &:disabled {
    background-color: ${props => props.theme.gray};
    cursor: not-allowed;
  }
`;

export const AccessGateLogo = styled.img`
  height: 6rem;
  width: auto;
  margin-bottom: 1rem;

  &:hover {
    cursor: pointer;
  }
`;
